<template>
  <div>
    <button class="mr-3 btn branches_btn" @click="downloadPdf(data.id)">
      {{ $t('text.clickButtons.download') }}
    </button>
  </div>
</template>

<script>

import configObject from "@/config";

export default {
  data () {
    return {
      data: {}
    }
  },
  
  methods: {
    downloadPdf(id) {
       this.$store.commit("setShowLineLoader", true)
      this.axios({
        url: `${configObject.apiBaseUrl}/Invoices/${this.$route.query.id}/receipt-to-pdf`,
        method: 'GET',
        headers: configObject.authConfig().headers,
        responseType: 'blob',
      }).then((response) => {
          let disposition = response.headers["content-disposition"];
          let depositionArr = disposition.split(";")[1]

          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', depositionArr.split("=")[1].split("_").join("_").replace(/["']/g, ""));
          document.body.appendChild(fileLink);

          fileLink.click();
         this.$store.commit("setShowLineLoader", false)
          this.$toast("Download Successful", {
              type: "success",
              timeout: 3000
          });
          this.isButtonDisabled = false;
            
      }).catch(e => {
       
        
      })
    },
    deleteReceipt(id) {
        let resp = confirm("Are you sure want to delete this payment receipt?");
        if (resp) {
            this.axios
            .delete(
                `${configObject.apiBaseUrl}/Invoices/${id}/receipt`,
                configObject.authConfig()
            )
            .then(() => {
                this.$toast("Successfully Deleted Payment Receipt", {
                    type: "success",
                    timeout: 3000,
                });
                this.$eventHub.$emit("refreshInvoiceReceipt");
            })
            .catch((error) => {
                this.$toast(error.response.data.message, {
                    type: "error",
                    timeout: 3000,
                });
            });
        }
    },
   
  },
}
</script>